export const AccountRoleType = {
  STAFF: '1',
  CLEANER: '2',
  MANAGER: '3',
  PUBLIC_API: '4',
  RESTAURANT: '5',
} as const
export type AccountRoleType = (typeof AccountRoleType)[keyof typeof AccountRoleType]

export type AccountType = { employee: { role: AccountRoleType } }

export const hasCleanerRole = (account: AccountType | undefined): boolean => {
  return hasRole([AccountRoleType.CLEANER], account?.employee.role)
}

export const hasStaffRole = (account: AccountType | undefined): boolean => {
  return hasRole([AccountRoleType.STAFF, AccountRoleType.MANAGER], account?.employee.role)
}

export const hasManagerRole = (account: AccountType | undefined): boolean => {
  return hasRole([AccountRoleType.MANAGER], account?.employee.role)
}

export const hasRestaurantOnlyRole = (account: AccountType | undefined): boolean => {
  return hasRole([AccountRoleType.RESTAURANT], account?.employee.role)
}

export const hasRestaurantOrAboveRole = (account: AccountType | undefined): boolean => {
  return hasRole([AccountRoleType.RESTAURANT, AccountRoleType.STAFF, AccountRoleType.MANAGER], account?.employee.role)
}

/** 画面ルートガード等の細粒度権限 UI の対象（MANAGER は従来どおり除外）。 */
export const usesHotelPmsStaffPermissions = (account: AccountType | undefined): boolean => {
  return hasRole([AccountRoleType.STAFF], account?.employee.role)
}

/** /employee-hotels/permissions の取得対象。清掃員・レストランは専用レイアウトで固定のため除外。 */
export const shouldFetchHotelPmsPermissions = (account: AccountType | undefined): boolean => {
  return Boolean(account && !hasCleanerRole(account) && !hasRestaurantOnlyRole(account))
}

const hasRole = (roleGroup: AccountRoleType[], accountRole: AccountRoleType | undefined): boolean => {
  if (!accountRole) {
    return false
  }
  return roleGroup.includes(accountRole)
}
